import { useFormContext } from "react-hook-form";
import CustomerInteractionClient from "@common/api/CustomerInteractionClient";
import { customerInteractionCreatePayload } from "@common/components/helpers/CustomerInteraction/customerInteractionSubmission";
import useLogin from "@common/components/hooks/useLogin";
import useComplianceAlerts from "./useComplianceAlerts";
import useCustomerInteraction from "./useCustomerInteraction";
import useCustomer from "./useCustomer";
import useCompliance from "./useCompliance";
import useLinkedAlert from "./useLinkedAlert";

const useCustomerInteractionForm = () => {
  const methods = useFormContext();
  const [{ siteGuid }] = useLogin();
  const {
    watch,
    formState: { errors, isValid },
  } = methods;
  const isCustomerVulnerable = watch("isCustomerVulnerable");
  const { complianceAlertId } = useCustomerInteraction();
  const { clearAlerts } = useComplianceAlerts();
  const { onSelectCustomer, onNewCustomer, onEditCustomer, onRemoveCustomer } =
    useCustomer();
  const { resetComplianceForms, submitComplianceForm } = useCompliance();
  const { linkedAlertData } = useLinkedAlert();
  const resetForm = () => resetComplianceForms(false);

  const onSubmit = (data) => {
    if (!isValid) {
      console.error(errors);
      return;
    }
    const payload = customerInteractionCreatePayload(
      data,
      siteGuid,
      linkedAlertData,
    );

    const callback = complianceAlertId
      ? clearAlerts([complianceAlertId], false)
      : () => {};

    submitComplianceForm({
      client: CustomerInteractionClient,
      payload,
      resetForm,
      callback,
    });
  };

  // Calling those methods here to pass down the formContext from react-hook-form
  const onSelect = (customerId) => onSelectCustomer(customerId);

  const handleNewCustomer = (customer) => onNewCustomer(customer);

  const handleEditCustomer = (customer) => onEditCustomer(customer);

  const handleRemoveCustomer = () => onRemoveCustomer();

  const handleExistingCustomer = (response) =>
    handleNewCustomer(response.data[0]);

  return {
    methods,
    isCustomerVulnerable,
    onSubmit,
    resetForm,
    onSelect,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
    handleExistingCustomer,
  };
};

export default useCustomerInteractionForm;
